import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";

import {
  FaDiscord,
  FaYoutube,
  FaGithub,
  FaRedditAlien,
  FaInstagram,
  FaLinkedinIn,
  FaFacebookF,
} from "react-icons/fa";

const communityLinks = [
  {
    name: "Discord",
    icon: FaDiscord,
    href: "https://discord.gg/MqwUN5YXPh",
  },
  {
    name: "Youtube",
    icon: FaYoutube,
    href: "https://www.youtube.com/@TakamoriRobot",
  },
  {
    name: "Github",
    icon: FaGithub,
    href: "https://github.com/TakamoriRobot/HIRO",
  },
  {
    name: "Reddit",
    icon: FaRedditAlien,
    href: "https://www.reddit.com/r/TakamoriRobot/",
  },
  {
    name: "Instagram",
    icon: FaInstagram,
    href: "https://www.instagram.com/takamori_robot/",
  },
  {
    name: "LinkedIn",
    icon: FaLinkedinIn,
    href: "https://www.linkedin.com/company/takamori-robot",
  },
  {
    name: "Facebook",
    icon: FaFacebookF,
    href: "https://www.facebook.com/profile.php?id=61575609549357",
  },
];

export default function Community() {
  return (
    <div className="flex min-h-screen w-full flex-col">
      <Header />

      <main className="flex flex-1 flex-col items-center bg-white px-6 py-[3rem]">
        <h1 className="mb-[4rem] text-center text-2xl font-bold text-black md:text-3xl">
          Come Join the Takamori Community!
        </h1>

        <div className="grid w-full max-w-[700px] grid-cols-2 gap-x-[3rem] gap-y-[3.5rem] sm:grid-cols-3 lg:grid-cols-4">
          {communityLinks.map(({ name, icon: Icon, href }) => (
            <a
              key={name}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={`Visit Takamori Robot on ${name}`}
              className="flex flex-col items-center justify-center gap-y-2 text-black transition-transform hover:scale-105"
            >
              <div className="flex h-[5rem] w-[5rem] items-center justify-center rounded-full bg-[#333A34] text-white">
                <Icon className="text-[3rem]" />
              </div>

              <span className="text-lg font-semibold">{name}</span>
            </a>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
}